// extracted by mini-css-extract-plugin
module.exports = {"container":"partials-background-container","inner":"partials-background-inner","letters":"partials-background-letters","letter":"partials-background-letter"};